import React from 'react';
import { ChildrenOwnerProps } from '../Base';

export default function BorderedContainer(props: ChildrenOwnerProps) {
  return <div className="w-full rounded-md border-4 border-mint-medical-green-lighter p-2">{props.children}</div>;
}
